module.exports = __webpack_public_path__ + "static/work27-0a4383de80652347a31f3dd16b551888.jpg";